'use client';

import { useMemo } from 'react';

import { Product } from '@/entities/product';
import { useUserStore } from '@/features/user';

import { useAuthFavoriteStore } from './authFavoriteStore';
import { useFavoriteGuestStore } from './favoriteGuestStore';
import { useFavoritePendingUiStore } from './favoritePendingUiStore';

export function useFavoriteHeartState(product: Product) {
  const isAuth = useUserStore((s) => s.isAuth);
  const guestEntries = useFavoriteGuestStore((s) => s.entries);
  const authEntries = useAuthFavoriteStore((s) => s.entries);
  const pendingIds = useFavoritePendingUiStore((s) => s.ids);

  return useMemo(() => {
    const inFavorites = isAuth
      ? authEntries.some((e) => e.id === product.id)
      : guestEntries.some((e) => e.id === product.id);
    const pendingRemove = pendingIds.includes(product.id);
    const filled = inFavorites && !pendingRemove;

    return { inFavorites, pendingRemove, filled };
  }, [isAuth, guestEntries, authEntries, pendingIds, product.id]);
}
